import { render, staticRenderFns } from "./MidwifePropertyDetail.vue?vue&type=template&id=07ee4760"
import script from "./MidwifePropertyDetail.vue?vue&type=script&lang=js"
export * from "./MidwifePropertyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports